import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from 'src/app/core/data.service';

@Injectable({
  providedIn: 'root'
})
export class FaqServiceService {

  constructor(private dataService: DataService) { }

  //Get method to get list of FAQ
  getFAQDetails(): Observable<any> {
    return this.dataService.getRequest('general/faq');
  }

  //Get method to get FAQ
  getFAQById(faqId:any): Observable<any> {
    return this.dataService.getRequest('general/faqid?fAQId='+faqId);
  }
}
